import React, { useEffect, useRef, useState } from 'react';
import Icons from '../Icons/Icons';
import MiniCartUtil from '../../utils/miniCart';
import ResponsiveImage from '../ResponsiveImage/ShopifyResponsiveImage';
import SimpleBar from 'simplebar-react';
import { formatPrice } from '../../utils/utilities';
import { getSelectedLanguage } from '../../utils/regionUtil';
const MiniCart = ({ locale_title, locale_quantity, locale_empty, locale_cart, locale_checkout, locale_continue }) => {
    const [cartItems, setCartItems] = useState([]);
    const [itemCount, setItemCount] = useState(0);
    const [countHasChanged, setCountHasChanged] = useState(false);
    const [miniCartState, setMiniCartState] = useState(false);
    const [onCartPage, setOnCartPage] = useState(false);
    const [cartPath, setCartPath] = useState('/cart');
    const itemCountRef = useRef(null);
    const cartEmpty = cartItems.length === 0;
    const handleClick = (event) => {
        return;
        const minicartwindow = document.getElementById('header-cart');
        const target = event.target;
        if (!minicartwindow.contains(target)) {
            setMiniCartState(false);
        }
    };
    useEffect(() => {
        setOnCartPage(window.location.pathname === cartPath);
        MiniCartUtil.getCartItems().then((products) => {
            const sortedProducts = products.sort((a, b) => (a.product_type === 'First Tier Sample' || a.product_type === 'Second Tier Sample' || a.product_type !== 'Free Gift' ? 1 : -1));
            setCartItems(sortedProducts);
        });
        MiniCartUtil.getItemCount().then((count) => setItemCount(count));
        window.addEventListener('cart-updated', (event) => {
            setCartItems(event.detail.items);
            setItemCount(event.detail.count);
            setCountHasChanged(true);
        });
        window.addEventListener('click', handleClick);
        return () => window.removeEventListener('click', handleClick);
    }, [setCartItems, setItemCount, setCountHasChanged, setOnCartPage]);
    useEffect(() => {
        if (itemCount && itemCountRef.current && countHasChanged) {
            if (!itemCountRef.current || !itemCountRef.current.classList)
                return;
            itemCountRef.current.classList.add('header__bag-icon-count--added');
            setTimeout(() => {
                itemCountRef.current.classList.remove('header__bag-icon-count--added');
            }, 3000);
        }
    }, [itemCount, countHasChanged, itemCountRef]);
    useEffect(() => {
        const currentLang = getSelectedLanguage();
        setCartPath(currentLang ? `/${currentLang}/cart` : '/cart');
    }, []);
    const redirect = (path) => {
        setMiniCartState(false);
        window.location.pathname = path;
    };
    const toggleMiniCart = () => {
        const isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints;
        if (isTouchDevice) {
            return;
        }
        else {
            //setMiniCartState(true);
        }
    };
    const onCartIconPress = () => {
        return;
        if (miniCartState === true) {
            redirect(cartPath);
        }
        else {
            setMiniCartState(true);
        }
    };
    const goToCheckout = () => {
        window.location.href = '/checkout';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onMouseEnter: toggleMiniCart, onClick: onCartIconPress, className: "header__bag-icon", role: "button", tabIndex: 0, "aria-label": "Open cart" },
            React.createElement(Icons.Bag, null),
            itemCount >= 10 && (React.createElement("div", { ref: itemCountRef, className: "header__bag-icon-count double-digits" }, itemCount)),
            itemCount > 0 && itemCount < 10 && (React.createElement("div", { ref: itemCountRef, className: "header__bag-icon-count" }, itemCount))),
        !!miniCartState && (React.createElement("div", { className: "mini-cart visually-hidden" },
            React.createElement("div", { className: "mini-cart__cross", onClick: () => setMiniCartState(false) },
                React.createElement(Icons.Close, null)),
            React.createElement("h3", { className: "mini-cart__title" }, locale_title),
            React.createElement(SimpleBar, { style: { maxHeight: 'calc(100vh - 29.8rem)' } },
                cartItems &&
                    cartItems.map((product) => {
                        let product_title = product.title;
                        if (product.product_type === 'eGift Card') {
                            product_title = product.title.split('[')[0];
                        }
                        return (React.createElement("div", { key: product.id, className: "mini-cart__product" },
                            React.createElement("div", { className: "mini-cart__product-image", tabIndex: -1 },
                                React.createElement(ResponsiveImage, { imageSrc: product.featured_image.url, imageAlt: product.featured_image.alt ? product.featured_image.alt : product_title, aspectRatio: product.featured_image.aspect_ratio })),
                            React.createElement("div", { className: "mini-cart__product-text-wrapper" },
                                product.product_type !== 'First Tier Sample' && product.product_type !== 'Second Tier Sample' ? (React.createElement("a", { href: product.url, className: "mini-cart__product-link" }, product_title)) : (React.createElement("p", { className: "mini-cart__product-title" }, product_title)),
                                React.createElement("div", { className: "mini-cart__product-details" },
                                    React.createElement("p", { className: "mini-cart__product-quantity" },
                                        locale_quantity,
                                        React.createElement("span", null, product.quantity)),
                                    product.product_type !== 'First Tier Sample' && product.product_type !== 'Second Tier Sample' && product.product_type !== 'Free Gift' && React.createElement("p", { className: "mini-cart__product-price" }, formatPrice(product.price))))));
                    }),
                cartEmpty && React.createElement("p", { className: "mini-cart__no-items" }, locale_empty)),
            React.createElement("div", { className: "mini-cart__button-wrapper" },
                React.createElement("button", { type: onCartPage ? 'submit' : 'button', className: "mini-cart__button", id: "mini-cart__button", name: onCartPage ? 'checkout' : '', onClick: () => (cartEmpty ? redirect('/collections/all-products') : onCartPage ? goToCheckout() : redirect(cartPath)) }, cartEmpty ? locale_continue : onCartPage ? locale_checkout : locale_cart))))));
};
export default MiniCart;
